<nav class="sidebar pl-0 pr-0" [ngStyle]="{'min-height.px': minHeight}"
    [ngClass]="{sidebarPushRight: isActive, collapsed: collapsed}">
    <div class="list-group">
        <!--dashboard-->
        <div class="nested-menu" *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR','ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_PROGRAM_SUPPORT']">
            <a class="list-group-item" (click)="addExpandClass('dashboards')" tabindex="0" role="button"
                [attr.aria-expanded]="!!showMenu['dashboards']" (keydown.enter)="addExpandClass('dashboards')"
                (keydown.space)="addExpandClass('dashboards')">
                <i class="fal fa-user-chart fa-side-nav-icon fa-fw"></i>
                <span class="k-text-uppercase">{{ 'DASHBOARD' | translate:patientLabel }}<span *ngIf="noticeCount > 0"
                        class="badge badge-pill badge-secondary count-badge"
                        title="{{'NOTICES' | translate}}">{{noticeCount}}</span>
                </span>
                <i class="arrow fal" [ngClass]="showMenu['dashboards'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </a>
            <ul class="main">
                <li class="nested" [class.expand]="showMenu['dashboards']">
                    <ul class="submenu">
                        <li>
                            <a [routerLink]="['dashboards/all']" [routerLinkActive]="['router-link-active']">
                                <span>{{ 'ALL' | translate }}</span>
                            </a>
                        </li>
                        <li *ngFor="let item of menuItems.dashboards.items" class="ellipsis-menu"
                            [contextMenu]="contextMenuDashboards" [contextMenuValue]="item.id">
                            <a [routerLink]="['/dashboards', item.id]" title="{{item.name}}"
                                [routerLinkActive]="['router-link-active']">
                                <span>{{item.name}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!--Members-->
        <div class="nested-menu"
            *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR','ROLE_PROGRAM_LEAD','ROLE_PROGRAM_SUPPORT','ROLE_OPERATOR','ROLE_COMMUNITY_COORDINATOR']">
            <a class="list-group-item" (click)="addExpandClass('members')" tabindex="0" role="button"
                [attr.aria-expanded]="!!showMenu['members']" (keydown.enter)="addExpandClass('members')"
                (keydown.space)="addExpandClass('members')">
                <i class="fal fa-users fa-side-nav-icon fa-fw"></i>
                <span class="k-text-uppercase">{{ 'MEMBERS' | translate:patientLabel }}</span>
                <i class="arrow fal" [ngClass]="showMenu['members'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </a>
            <ul class="main">
                <li class="nested" [class.expand]="showMenu['members']">
                    <ul class="submenu">
                        <li>
                            <a [routerLink]="['members-search']" [routerLinkActive]="['router-link-active']">
                                <span>{{ 'SEARCH' | translate }}</span>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['members/all']" [routerLinkActive]="['router-link-active']">
                                <span>{{ 'ALL' | translate }}</span>
                            </a>
                        </li>
                        <li [contextMenu]="contextMenuRecent" [contextMenuValue]="'members'">
                            <a [routerLink]="['members/recent']" [routerLinkActive]="['router-link-active']">
                                <span>{{ 'RECENT' | translate }}</span>
                            </a>
                        </li>
                        <li *ngFor="let item of menuItems.members.items" class="ellipsis-menu"
                            [contextMenu]="contextMenuMembers" [contextMenuValue]="item.id">
                            <a [routerLink]="['/members', item.id]" title="{{item.name}}"
                                [routerLinkActive]="['router-link-active']">
                                <span>{{item.name}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!--Programs-->
        <div class="nested-menu"
            *ngxPermissionsOnly="['ROLE_PROGRAM_LEAD','ROLE_PROGRAM_SUPPORT','ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR']">
            <a class="list-group-item" (click)="addExpandClass('programs')" tabindex="0" role="button"
                [attr.aria-expanded]="!!showMenu['programs']" (keydown.enter)="addExpandClass('programs')"
                (keydown.space)="addExpandClass('programs')">
                <i class="fal fa-cubes fa-side-nav-icon fa-fw"></i>
                <span class="k-text-uppercase">{{ 'PROGRAMS' | translate }}</span>
                <i class="arrow fal" [ngClass]="showMenu['programs'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </a>
            <ul class="main">
                <li class="nested" [class.expand]="showMenu['programs']">
                    <ul class="submenu">
                        <li>
                            <a [routerLink]="['programs/all']" [routerLinkActive]="['router-link-active']">
                                <span>{{ 'ALL' | translate }}</span>
                            </a>
                        </li>
                        <li *ngFor="let item of menuItems.programs.items" class="ellipsis-menu"
                            [contextMenu]="contextMenuPrograms" [contextMenuValue]="item.id">
                            <a [routerLink]="['/programs', item.id]" title="{{item.name}}"
                                [routerLinkActive]="['router-link-active']">
                                <span>{{item.name}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!--Cases-->
        <div class="nested-menu"
            *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR','ROLE_PROGRAM_LEAD','ROLE_PROGRAM_SUPPORT','ROLE_OPERATOR','ROLE_COMMUNITY_COORDINATOR']">
            <a class="list-group-item" (click)="addExpandClass('cases')" tabindex="0" role="button"
                [attr.aria-expanded]="!!showMenu['cases']" (keydown.enter)="addExpandClass('cases')"
                (keydown.space)="addExpandClass('cases')">
                <i class="fal fa-folders fa-side-nav-icon fa-fw"></i>
                <span class="k-text-uppercase">{{ 'CASES' | translate }}</span>
                <i class="arrow fal" [ngClass]="showMenu['cases'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </a>
            <ul class="main">
                <li class="nested" [class.expand]="showMenu['cases']">
                    <ul class="submenu">
                        <li>
                            <a [routerLink]="['cases/active']" [routerLinkActive]="['router-link-active']">
                                <span>{{ 'ACTIVE' | translate }}</span>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['cases/all']" [routerLinkActive]="['router-link-active']">
                                <span>{{'ALL' | translate}}</span>
                            </a>
                        </li>
                        <li [contextMenu]="contextMenuRecent" [contextMenuValue]="'cases'">
                            <a [routerLink]="['cases/recent']" [routerLinkActive]="['router-link-active']">
                                <span>{{ 'RECENT' | translate }}</span>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['cases/my']" [routerLinkActive]="['router-link-active']">
                                <span>{{'MY-OPEN-CASES' | translate}}</span>
                            </a>
                        </li>
                        <li *ngFor="let item of menuItems.cases.items" class="ellipsis-menu"
                            [contextMenu]="contextMenuCases" [contextMenuValue]="item.id">
                            <a [routerLink]="['/cases', item.id]" title="{{item.name}}"
                                [routerLinkActive]="['router-link-active']">
                                <span>{{item.name}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!--Tasks-->
        <div class="nested-menu"
            *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR','ROLE_PROGRAM_LEAD','ROLE_PROGRAM_SUPPORT','ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR']">
            <a class="list-group-item" (click)="addExpandClass('tasks')" tabindex="0" role="button"
                [attr.aria-expanded]="!!showMenu['tasks']" (keydown.enter)="addExpandClass('tasks')"
                (keydown.space)="addExpandClass('tasks')">
                <i class="fal fa-tasks fa-side-nav-icon fa-fw"></i>
                <span class="k-text-uppercase">{{ 'TASKS' | translate }}</span>
                <i class="arrow fal" [ngClass]="showMenu['tasks'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </a>
            <ul class="main">
                <li class="nested" [class.expand]="showMenu['tasks']">
                    <ul class="submenu">
                        <li>
                            <a [routerLink]="['tasks/active']" [routerLinkActive]="['router-link-active']">
                                <span>{{ 'ACTIVE' | translate }}</span>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['tasks/my']" [routerLinkActive]="['router-link-active']">
                                <span>{{'MY-OPEN-TASKS' | translate}}</span>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['tasks/completed']" [routerLinkActive]="['router-link-active']">
                                <span>{{ 'COMPLETED' | translate }}</span>
                            </a>
                        </li>
                        <li *ngFor="let item of menuItems.tasks.items" class="ellipsis-menu"
                            [contextMenu]="contextMenuTasks" [contextMenuValue]="item.id">
                            <a [routerLink]="['/tasks', item.id]" title="{{item.name}}"
                                [routerLinkActive]="['router-link-active']">
                                <span>{{item.name}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <div class="nested-menu" *ngxPermissionsOnly="['ROLE_REFERRAL_COORDINATOR']">
            <a class="list-group-item" (click)="addExpandClass('referral-tasks')" tabindex="0" role="button"
                [attr.aria-expanded]="!!showMenu['referral-tasks']" (keydown.enter)="addExpandClass('referral-tasks')"
                (keydown.space)="addExpandClass('referral-tasks')">
                <i class="fal fa-tasks fa-side-nav-icon fa-fw"></i>
                <span class="k-text-uppercase">{{ 'REFERRALS' | translate }}</span>
                <i class="arrow fal" [ngClass]="showMenu['referral-tasks'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </a>
            <ul class="main">
                <li class="nested" [class.expand]="showMenu['referral-tasks']">
                    <ul class="submenu">
                        <li>
                            <a [routerLink]="['referral-tasks/my']" [routerLinkActive]="['router-link-active']">
                                <span>{{'MY-OPEN-REFERRALS' | translate}}</span>
                            </a>
                        </li>
                        <li *ngFor="let item of menuItems.referralTasks.items" class="ellipsis-menu"
                            [contextMenu]="contextMenuReferralTasks" [contextMenuValue]="item.id">
                            <a [routerLink]="['/referral-tasks', item.id]" title="{{item.name}}"
                                [routerLinkActive]="['router-link-active']">
                                <span>{{item.name}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!--Payer Billing-->
        <div>
            <div class="nested-menu"
                *ngxPermissionsOnly="['ROLE_REVENUE_MANAGER_OPERATOR', 'ROLE_REVENUE_MANAGER_ANALYST']">
                <a class="list-group-item" [routerLink]="['payer-billing']" [routerLinkActive]="['router-link-active']">
                    <i class="fal fa-money-bill fa-side-nav-icon fa-fw"></i>
                    <span class="k-text-uppercase">{{ 'PAYER-BILLING' | translate }}</span>
                </a>
            </div>
        </div>
        <!--CBO Payments-->
        <div>
            <div class="nested-menu"
                *ngxPermissionsOnly="['ROLE_REVENUE_MANAGER_OPERATOR', 'ROLE_CBO_REVENUE_ANALYST']">
                <a class="list-group-item" [routerLink]="['cbo-payments']" [routerLinkActive]="['router-link-active']">
                    <i class="fal fa-money-check-edit-alt fa-side-nav-icon fa-fw"></i>
                    <span class="k-text-uppercase">{{ 'CBO-PAYMENTS' | translate }}</span>
                </a>
            </div>
        </div>
        <!--Messages-->
        <div *ngIf="accessMessages">
            <div class="nested-menu"
                *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR','ROLE_PROGRAM_LEAD','ROLE_PROGRAM_SUPPORT','ROLE_OPERATOR', 'ROLE_COMMUNITY_COORDINATOR', 'ROLE_REFERRAL_COORDINATOR', 'ROLE_DIRECTORY_MANAGER', 'ROLE_DATA_ANALYST', 'ROLE_REVENUE_MANAGER_OPERATOR', 'ROLE_REVENUE_MANAGER_ANALYST', 'ROLE_CBO_REVENUE_ANALYST']">
                <a class="list-group-item" (click)="addExpandClass('messages')" tabindex="0" role="button"
                    [attr.aria-expanded]="!!showMenu['messages']" (keydown.enter)="addExpandClass('messages')"
                    (keydown.space)="addExpandClass('messages')">
                    <i class="fal fa-envelope fa-side-nav-icon fa-fw"></i>
                    <span class="k-text-uppercase">{{ 'MESSAGES' | translate }}</span><span *ngIf="unreadMessages > 0"
                        class="badge badge-pill badge-secondary count-badge" title="{{'UNREAD' | translate}}"
                        [ngClass]="{'hidden': collapsed}">{{unreadMessages}}</span>
                    <i class="arrow fal" [ngClass]="showMenu['messages'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
                </a>
                <ul class="main">
                    <li class="nested" [class.expand]="showMenu['messages']">
                        <ul class="submenu">
                            <li>
                                <a [routerLink]="['messages/inbox']" [routerLinkActive]="['router-link-active']">
                                    <span>{{ 'INBOX' | translate }}</span>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['messages/sent']" [routerLinkActive]="['router-link-active']">
                                    <span>{{ 'SENT' | translate }}</span>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['messages/deleted']" [routerLinkActive]="['router-link-active']">
                                    <span>{{ 'DELETED' | translate }}</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <!--Chats-->
        <div *ngIf="accessChats">
            <div class="nested-menu">
                <a class="list-group-item" (click)="openChat()" tabindex="0" (keydown.enter)="openChat()"
                    (keydown.space)="openChat()">
                    <i class="fal fa-comment-alt-lines fa-side-nav-icon fa-fw"></i>
                    <span class="k-text-uppercase">{{ 'CHAT' | translate }}</span><span *ngIf="unreadChats > 0"
                        class="badge badge-pill badge-secondary count-badge" title="{{'UNREAD' | translate}}"
                        [ngClass]="{'hidden': collapsed}">{{unreadChats}}</span>
                </a>
            </div>
        </div>
        <!--Reports-->
        <div *ngIf="accessReports">
            <div class="nested-menu">
                <a class="list-group-item" [routerLink]="['reports']" [routerLinkActive]="['router-link-active']">
                    <i class="fal fa-file-invoice fa-side-nav-icon fa-fw"></i>
                    <span class="k-text-uppercase">{{ 'REPORTS' | translate }}</span>
                </a>
            </div>
        </div>
        <!--Services Search-->
        <div *ngIf="accessCommunityServiceSearch">
            <div class="nested-menu">
                <a class="list-group-item" [routerLink]="['community-services-search']"
                    [routerLinkActive]="['router-link-active']">
                    <i class="fal fa-search-location fa-side-nav-icon fa-fw"></i>
                    <span class="k-text-uppercase">{{ 'COMMUNITY' | translate:communityLabel }}</span>
                </a>
            </div>
        </div>
        <!--Find Provider-->
        <div *ngIf="accessProviders">
            <div class="nested-menu">
                <div *ngIf="!kno2Enabled && providerEnabled">
                    <a class="list-group-item" [routerLink]="['providers-search']"
                        [routerLinkActive]="['router-link-active']">
                        <i class="fal fa-search-location fa-side-nav-icon fa-fw"></i>
                        <span class="k-text-uppercase">{{ 'FIND-PROVIDER' | translate }}</span>
                    </a>
                </div>
                <div *ngIf="kno2Enabled && providerEnabled">
                    <a class="list-group-item" (click)="addExpandClass('providers')" tabindex="0" role="button"
                        [attr.aria-expanded]="!!showMenu['providers']" (keydown.enter)="addExpandClass('providers')"
                        (keydown.space)="addExpandClass('providers')">
                        <i class="fal fa-search-location fa-side-nav-icon fa-fw"></i>
                        <span class="k-text-uppercase">{{ 'FIND-PROVIDER' | translate }}</span>
                        <i class="arrow fal" [ngClass]="showMenu['providers'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
                    </a>
                    <ul class="main">
                        <li class="nested" [class.expand]="showMenu['providers']">
                            <ul class="submenu">
                                <li>
                                    <a [routerLink]="['providers-search']" [routerLinkActive]="['router-link-active']">
                                        <span>{{ 'CHANNELS' | translate }}</span>
                                    </a>
                                </li>
                                <li>
                                    <a [routerLink]="['kno2-search']" [routerLinkActive]="['router-link-active']">
                                        <span>{{ 'PROVIDER-KNO2' | translate }}</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!--Analytics-->
        <div *ngIf="accessAnalytics && menuItems.analytics.items && menuItems.analytics.items.length > 0">
            <div class="nested-menu">
                <a class="list-group-item" (click)="addExpandClass('analytics')" tabindex="0" role="button"
                    [attr.aria-expanded]="!!showMenu['analytics']" (keydown.enter)="addExpandClass('analytics')"
                    (keydown.space)="addExpandClass('analytics')">
                    <i class="fal fa-analytics fa-side-nav-icon fa-fw"></i>
                    <span class="k-text-uppercase">{{ 'ANALYTICS' | translate }}</span>
                    <i class="arrow fal" [ngClass]="showMenu['analytics'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
                </a>
                <ul class="main">
                    <li class="nested" [class.expand]="showMenu['analytics']">
                        <ul class="submenu">
                            <li *ngFor="let item of menuItems.analytics.items" class="ellipsis-menu">
                                <a [routerLink]="['/analytics', item.id]" title="{{item.name}}"
                                    [routerLinkActive]="['router-link-active']">
                                    <span>{{item.name}}</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <!--Settings-->
        <div *ngIf="settingItems.length > 0 && !displaySettingsMenuCard">
            <div class="nested-menu"
                *ngxPermissionsOnly="['ROLE_SYSTEM_OPERATOR','ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_PROGRAM_SUPPORT', 'ROLE_COMMUNITY_ADMIN', 'ROLE_COMMUNITY_COORDINATOR', 'ROLE_DIRECTORY_MANAGER', 'ROLE_REVENUE_MANAGER_OPERATOR']">
                <a class="list-group-item" (click)="addExpandClass('settings')" tabindex="0" role="button"
                    [attr.aria-expanded]="!!showMenu['settings']" (keydown.enter)="addExpandClass('settings')"
                    (keydown.space)="addExpandClass('settings')">
                    <i class="fal fa-cogs fa-side-nav-icon fa-fw"></i>
                    <span class="k-text-uppercase">{{ 'SETTINGS' | translate }}</span>
                    <i class="arrow fal" [ngClass]="showMenu['settings'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
                </a>
                <ul class="main">
                    <li class="nested" [class.expand]="showMenu['settings']">
                        <ul class="submenu">
                            <div *ngFor="let item of settingItems; let i = index;">
                                <li *ngxPermissionsOnly="settingItems[i].permissions">
                                    <a [routerLink]="item.route" [routerLinkActive]="['router-link-active']"
                                        title="{{item.descriptionKey | translate }}">
                                        <span>{{ item.titleKey | translate:patientLabel }}</span>
                                    </a>
                                </li>
                            </div>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <!--Settings Tile Navigation-->
        <div *ngIf="settingItems.length > 0 && displaySettingsMenuCard">
            <div class="nested-menu"
                *ngxPermissionsOnly="['ROLE_SYSTEM_OPERATOR','ROLE_OPERATOR', 'ROLE_PROGRAM_LEAD', 'ROLE_PROGRAM_SUPPORT', 'ROLE_COMMUNITY_ADMIN', 'ROLE_COMMUNITY_COORDINATOR', 'ROLE_DIRECTORY_MANAGER', 'ROLE_REVENUE_MANAGER_OPERATOR']">
                <a class="list-group-item" [routerLink]="['settings']" [routerLinkActive]="['router-link-active']">
                    <i class="fal fa-cogs fa-side-nav-icon fa-fw"></i>
                    <span class="k-text-uppercase">{{ 'SETTINGS' | translate }}</span>
                </a>
            </div>
        </div>
        <!--Clinical Events-->
        <div class="nested-menu" *ngxPermissionsOnly="['ROLE_OPERATOR']">
            <a class="list-group-item" (click)="addExpandClass('events')" tabindex="0" role="button"
                [attr.aria-expanded]="!!showMenu['events']" (keydown.enter)="addExpandClass('events')"
                (keydown.space)="addExpandClass('events')">
                <i class="fal fa-inbox-in fa-side-nav-icon fa-fw"></i>
                <span class="k-text-uppercase">{{ 'EVENTS' | translate }}</span>
                <i class="arrow fal" [ngClass]="showMenu['events'] ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </a>
            <ul class="main">
                <li class="nested" [class.expand]="showMenu['events']">
                    <ul class="submenu">
                        <li>
                            <a [routerLink]="['events/all']" [routerLinkActive]="['router-link-active']">
                                <span>{{'ALL' | translate}}</span>
                            </a>
                        </li>
                        <li *ngFor="let item of menuItems.events.items" class="ellipsis-menu"
                            [contextMenu]="contextMenuEvents" [contextMenuValue]="item.id">
                            <a [routerLink]="['/events', item.id]" title="{{item.name}}"
                                [routerLinkActive]="['router-link-active']">
                                <span>{{item.name}}</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!--Collapse/Expand-->
        <div class="nested-menu" (click)="toggleCollapsed()" tabindex="0" (keydown.enter)="toggleCollapsed()"
            (keydown.space)="toggleCollapsed()" title="{{ (collapsed?'EXPAND-NAV':'COLLAPSE-NAV') | translate }}">
            <a class="list-group-item">
                <i class="fal fa-fw fa-angle-custom"
                    [ngClass]="{'fa-angle-left': !collapsed, 'fa-angle-right': collapsed}"></i>
                <span style="padding-left:15px;position: relative;top: -5px;">{{ (collapsed?'EXPAND-NAV':'COLLAPSE-NAV')
                    | translate }}
                </span>
            </a>
        </div>
    </div>
    <context-menu #contextMenuPrograms>
        <ng-template contextMenuItem (execute)="deleteFilter($event,'programs')">
            <button class="dropdown-item k-text-uppercase col-2 ml-2">
                <i class="fas fa-trash-alt mr-2"></i>{{'DELETE' | translate }}
            </button>
        </ng-template>
    </context-menu>
    <context-menu #contextMenuTasks>
        <ng-template contextMenuItem (execute)="deleteFilter($event,'tasks')">
            <button class="dropdown-item k-text-uppercase col-2 ml-2">
                <i class="fas fa-trash-alt mr-2"></i>{{'DELETE' | translate }}
            </button>
        </ng-template>
    </context-menu>
    <context-menu #contextMenuReferralTasks>
        <ng-template contextMenuItem (execute)="deleteFilter($event,'referralTasks')">
            <button class="dropdown-item k-text-uppercase col-2 ml-2">
                <i class="fas fa-trash-alt mr-2"></i>{{'DELETE' | translate }}
            </button>
        </ng-template>
    </context-menu>
    <context-menu #contextMenuCases>
        <ng-template contextMenuItem (execute)="deleteFilter($event,'cases')">
            <button class="dropdown-item k-text-uppercase col-2 ml-2">
                <i class="fas fa-trash-alt mr-2"></i>{{'DELETE' | translate }}
            </button>
        </ng-template>
    </context-menu>
    <context-menu #contextMenuMembers>
        <ng-template contextMenuItem (execute)="deleteFilter($event,'members')">
            <button class="dropdown-item k-text-uppercase col-2 ml-2">
                <i class="fas fa-trash-alt mr-2"></i>{{'DELETE' | translate }}
            </button>
        </ng-template>
    </context-menu>
    <context-menu #contextMenuEvents>
        <ng-template contextMenuItem (execute)="editFilter($event,'Event')">
            <button class="dropdown-item k-text-uppercase col-2 ml-2">
                <i class="fas fa-edit mr-1"></i>{{'EDIT' | translate }}
            </button>
        </ng-template>
        <ng-template contextMenuItem (execute)="deleteFilter($event,'events')">
            <button class="dropdown-item k-text-uppercase col-2 ml-2">
                <i class="fas fa-trash-alt mr-2"></i>{{'DELETE' | translate }}
            </button>
        </ng-template>
    </context-menu>
    <context-menu #contextMenuDashboards>
        <ng-template contextMenuItem (execute)="deleteFilter($event,'dashboards')">
            <button class="dropdown-item k-text-uppercase col-2 ml-2">
                <i class="fas fa-trash-alt mr-2"></i>{{'DELETE' | translate }}
            </button>
        </ng-template>
    </context-menu>
    <context-menu #contextMenuRecent>
        <ng-template contextMenuItem (execute)="clearRecent($event)">
            <button class="dropdown-item k-text-uppercase col-2 ml-2 keyboard-accessible"
                (keydown.space)="clearRecent($event)" (keydown.enter)="clearRecent($event)">
                <i class="fas fa-times-circle fa-clear-custom mr-2"></i>{{'SEARCH-CLEAR-ALL' |
                translate }}
            </button>
        </ng-template>
    </context-menu>
</nav>
<!-- edit filter dialog -->
<app-save-filter [dialogOpened]="filterDialogOpened" [filterCategory]="filterCategory" [filterState]=""
    (cancelling)="filterDialogOpened=false;" [filter]="filter">
</app-save-filter>